import React from 'react';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  secondaryAction?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  secondaryAction,
  className = '',
}) => {
  return (
    <div className={`lattice-empty-state ${className}`.trim()}>
      {icon && <div className="lattice-empty-state__icon">{icon}</div>}
      <h3 className="lattice-empty-state__title">{title}</h3>
      {description && (
        <p className="lattice-empty-state__description">{description}</p>
      )}
      {(Boolean(action) || Boolean(secondaryAction)) && (
        <div className="lattice-empty-state__actions">
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
};
